<h1 class="text-center mt-6 pt-4" (click)="isOpen = !isOpen">
  <mat-icon [ngClass]="{ open: isOpen }">expand_more</mat-icon>
  {{ title }}
</h1>

<div class="card mt-3" *ngIf="isOpen">

  <p-fileUpload #fileUploader
                mode="advanced"
                [customUpload]="true"
                [auto]="false"
                [showUploadButton]="false"
                [showCancelButton]="false"
                [showButtons]="false"  
                accept=".xlsx"
                [multiple]="false"
                [showFileList]="false"
                (onSelect)="onUpload($event)"
                class="w-full">

    <!-- Custom Toolbar -->

    <ng-template pTemplate="toolbar">

      <div class="flex gap-2 align-items-center">

        <button pButton
                type="button"
                icon="pi pi-plus"
                label="Choose"
                (click)="fileUploader.advancedFileInput.nativeElement.click()">
        </button>

        <button pButton
                type="button"
                icon="pi pi-check"
                label="Submit"
                class="p-button-success"
                (click)="onSubmit()"
                [disabled]="uploadedFiles.length === 0">
        </button>
        <p-toast></p-toast>

     </div>
    </ng-template>

    <!-- Custom Drop Area + File Preview -->
    <ng-template pTemplate="content">

      <div class="w-full py-4 flex flex-column align-items-center">

        <!-- Drag-drop empty state -->
        <div *ngIf="!uploadedFiles.length"
             class="border-dashed border-2 border-gray-300 p-4 rounded bg-gray-50 w-30rem flex align-items-center justify-content-center gap-3 cursor-pointer"
             (click)="fileUploader.advancedFileInput.nativeElement.click()">
          <i class="pi pi-upload text-3xl text-500"></i>
          <span class="font-medium text-gray-700" style="margin-left: 1rem;">Drop or select a file</span>
       
        </div>

        <!-- File Preview -->
        <div class="file-preview mt-3 flex items-center justify-center gap-4 border-round bg-gray-100 p-3 shadow-2 w-full max-w-lg"
             *ngIf="uploadedFiles.length">

          <!-- Delete Icon -->
          <button pButton
                  pRipple
                  icon="pi pi-times"
                  pTooltip="Remove file"
                  tooltipPosition="top"
                  class="p-button-text p-button-plain p-button-rounded text-red-600"
                  (click)="removeImage($event, uploadedFiles[0])">
          </button>

          <!-- File Icon -->
          <i class="pi pi-file-excel text-3xl text-green-600"></i>

          <!-- File Name -->
          <span class="text-center text-sm truncate flex-grow" [title]="uploadedFiles[0].name">
            {{ uploadedFiles[0].name }}
          </span>
        </div>

      </div>
    </ng-template>
  </p-fileUpload>
</div>
